import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import userLocalStorage from '../services/userLocalStorage';
const useGetUserLocalStorage = (storageKey, userId) => {
  const $ = _c(7);
  const [hasRetrieved, setHasRetrieved] = useState(false);
  const [storedData, setStoredData] = useState();
  let t0;
  let t1;
  if ($[0] !== storageKey || $[1] !== userId) {
    t0 = () => {
      let isCancelled = false;
      const getStoredData = async () => {
        const localStorageData = await userLocalStorage.getItem(storageKey, String(userId));
        if (!isCancelled) {
          setStoredData(localStorageData);
          setHasRetrieved(true);
        }
      };
      getStoredData();
      return () => {
        isCancelled = true;
      };
    };
    t1 = [storageKey, userId];
    $[0] = storageKey;
    $[1] = userId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== hasRetrieved || $[5] !== storedData) {
    t2 = {
      hasRetrieved,
      data: storedData
    };
    $[4] = hasRetrieved;
    $[5] = storedData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useGetUserLocalStorage;